import { TableColumn, utils } from "@vilocnv/allsetra-core";
import ReportObjectNameCell from "components/common/reports/ReportObjectNameCell";
import moment from "moment";
import {
  COMMON_REPORT_INNER_TABLE_COLUMNS,
  COMMON_REPORT_TABLE_COLUMNS
} from "./commonReportsConstants";
import { calculateCO2Emissions } from "app/data/helpers";
import {
  renderAddressCell,
  getResolvedAddressForCell
} from "app/data/helpers/ReportHelpers/addressRenderHelper";

export const CO2_REPORT_DATE_RENDERING: TableColumn<any>[] = [
  {
    selector: (row: any) => <div style={{ width: "220px" }}>{row.label}</div>
  },
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {
    selector: (row: any) => (
      <div style={{ paddingLeft: "60px" }}>
        {calculateCO2Emissions(row.data) + " g/km "}
      </div>
    )
  }
];

export const CO2_REPORT_TABLE_COLUMNS = (
  translator: any,
  isShowKeyCol: boolean
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.rideNumber", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => (
      <ReportObjectNameCell name={row?.name} isInactive={row?.isInactive} />
    ),
    wrap: true
  },
  {
    name: translator("tableHeading.startTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.endTime", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.startAddress", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.endAddress", {
      ns: "tableHeadingsTranslation"
    })
  },
  ...COMMON_REPORT_TABLE_COLUMNS(translator, isShowKeyCol),
  {
    name: "CO2",
    selector: (row: any) => (
      <div style={{ paddingLeft: "60px" }}>{row?.CO2Emissions || "0"}</div>
    )
  }
];

export const CO2_REPORT_INNER_TABLE_COLUMNS = (
  translator: any,
  isShowKeyCol?: boolean,
  resolvedAddresses?: Array<any>,
  resolvedAddressLoading?: boolean
) => {
  return [
    { selector: (row: any) => row?.rideId || "-" },
    {
      selector: (row: any) =>
        utils.formatDate({ date: row?.startDate, whenEmpty: "-" }),
      wrap: true
    },
    {
      selector: (row: any) =>
        utils.formatDate({ date: row?.endDate, whenEmpty: "-" }),
      wrap: true
    },
    {
      cell: (row: any) => {
        const resolvedStartAddress = getResolvedAddressForCell(
          row,
          resolvedAddresses || [],
          "start"
        );

        return renderAddressCell({
          latitude: row.startLatitude,
          longitude: row.startLongitude,
          resolvedAddress: resolvedStartAddress,
          translator,
          isLoading: resolvedAddressLoading,
          rideMode: row.rideMode
        });
      },
      wrap: true
    },
    {
      cell: (row: any) => {
        const resolvedEndAddress = getResolvedAddressForCell(
          row,
          resolvedAddresses || [],
          "end"
        );

        return renderAddressCell({
          latitude: row.endLatitude,
          longitude: row.endLongitude,
          resolvedAddress: resolvedEndAddress,
          translator,
          isLoading: resolvedAddressLoading,
          rideMode: row.rideMode
        });
      },
      wrap: true
    },
    ...COMMON_REPORT_INNER_TABLE_COLUMNS(translator, isShowKeyCol),
    {
      cell: (row: any) => {
        return `${row?.cO2Emissions ? `${Math.round(row?.cO2Emissions)} g/km` : "-"}`;
      }
    }
  ];
};

export const CO2_REPORT_HEADERS = [
  { label: "Object Name", key: "Object Name" },
  { label: "Ride", key: "Ride" },
  { label: "Start Mileage", key: "Start Mileage" },
  { label: "End Mileage", key: "End Mileage" },
  { label: "Start Time", key: "Start Time" },
  { label: "End Time", key: "End Time" },
  { label: "Start Address", key: "Start Address" },
  { label: "End Address", key: "End Address" },
  { label: "Key", key: "Key" },
  { label: "Key ID", key: "Key ID" },
  { label: "Driver", key: "Driver" },
  { label: "Ride Mode", key: "Ride Mode" },
  { label: "Distance", key: "Distance" },
  { label: "Ride Duration", key: "Ride Duration" },
  { label: "CO2", key: "CO2" }
];
